export default __webpack_public_path__ + "static/media/clipped1.fe5e0711.PNG";